module.exports = "/lucky-balls/img/header-intro.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/header-intro.png
// module id = 1060
// module chunks = 0